import { Box, UIProvider } from "src/components/UI";

const DirectDebitWrapper = ({ children }) => {
  return (
    <UIProvider>
      <Box
        paddingBottom={["48px"]}
        maxWidth={["100%", "1040px"]}
        margin="0 auto"
      >
        {children}
      </Box>
    </UIProvider>
  );
};

export default DirectDebitWrapper;
